/**
 * Calendar days from now until cutover instant (UTC-based day math for alignment with BE cutover job).
 */
export function daysUntilCutoverUtc(cutoverIso: string | null | undefined): number | null {
  if (!cutoverIso) return null
  const cut = Date.parse(cutoverIso)
  if (Number.isNaN(cut)) return null
  const now = Date.now()

  return Math.ceil((cut - now) / (1000 * 60 * 60 * 24))
}

/** True when wall-clock now is at or after the cutover instant (BE ISO string). */
export function isCutoverInstantReached(cutoverIso: string | null | undefined): boolean {
  if (!cutoverIso) return false
  const t = Date.parse(cutoverIso)
  if (Number.isNaN(t)) return false

  return Date.now() >= t
}
